import {
  AllowableProductModelDto,
  CaseType,
  OpenAndUpcomingSeasonAssortmentDto,
  OrderType,
} from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class AllowableAssortmentService {
  private crudService: CrudService<AllowableProductModelDto>;

  constructor() {
    this.crudService = new CrudService<any>('api/allowable-assortment');
  }

  public async getAllowableAssortment(
    accountId: string,
    orderType: OrderType | CaseType,
    orderDate: string,
    orderNumber?: string,
  ): Promise<AllowableProductModelDto[]> {
    const queryParams = new URLSearchParams();

    queryParams.set('accountId', accountId);
    queryParams.set('orderType', orderType);
    queryParams.set('orderDate', orderDate);

    if (orderNumber) {
      queryParams.set('orderNumber', orderNumber);
    }

    const validationResult = await this.crudService.do('get', `allowable-product-models?${queryParams}`);

    return validationResult.isValid() && validationResult.model
      ? validationResult.model
      : new Array<AllowableProductModelDto>();
  }

  public async getOpenAndUpcomingSeasonAssortment(accountId: string): Promise<OpenAndUpcomingSeasonAssortmentDto[]> {
    const queryParams = new URLSearchParams();

    queryParams.set('accountId', accountId);

    const validationResult = await this.crudService.do('get', `open-and-upcoming?${queryParams}`);

    return validationResult.isValid() && validationResult.model
      ? validationResult.model
      : new Array<OpenAndUpcomingSeasonAssortmentDto>();
  }
}
